import * as React from 'react';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Menu, MenuItem } from '@mui/material';
import { accentHover } from './darkFormStyles';

const navLinkSx = {
  color: '#19191A',
  fontWeight: 600,
  textTransform: 'none',
  fontSize: '0.95rem',
  transition: 'all 0.3s ease-in-out',
  '&:hover': {
    borderColor: accentHover,
    bgcolor: 'rgba(255,255,255,0.15)',
    transform: 'translateY(-2px)',
    boxShadow: '0 6px 16px rgba(0,0,0,0.25)',
    '&:active': {
      transform: 'translateY(0)',
    },
  },
};

/**
 * Public-facing header navigation shown to anonymous visitors, linking to
 * marketing/registration pages. Rendered by HeaderBanner when no user is
 * logged in.
 */
export default function LandingNavLinks() {
  const navigate = useNavigate();
  const [socialsAnchorEl, setSocialsAnchorEl] = useState<null | HTMLElement>(
    null
  );

  const closeSocialsMenu = () => setSocialsAnchorEl(null);

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: 1, md: 2 } }}>
      <Button sx={navLinkSx} onClick={() => navigate('/features-pricing')}>
        Features & Pricing
      </Button>
      <Button sx={navLinkSx} onClick={() => navigate('/find-barbers')}>
        Find a Barber
      </Button>

      <Button sx={navLinkSx} onClick={() => navigate('/user-login')}>
        Login
      </Button>

      <Button
        variant="contained"
        onClick={() => navigate('/get-started')}
        sx={{
          bgcolor: '#dd8709',
          fontWeight: 'bold',
          textTransform: 'none',
          px: 3,
          '&:hover': { bgcolor: '#b86e08' },
        }}
      >
        List your business
      </Button>
    </Box>
  );
}
